import React, { useEffect, useMemo, useState } from 'react'
import { Form, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { AiOutlineCheck, AiOutlineClose, AiOutlineDash} from "react-icons/ai";
import styles from '../styles.module.scss'
import Button from '../../../components/Button';
import { createComissionApprove, deleteComissionApprove, toggleExpertAbsentStatus } from '../../../actions/common';
import { createNotification } from '../../../components/Notifications/Notifications';
import moment from 'moment';
import Switch from '../../../components/Switch'

const statuses = [
  {value: 1, name: 'За'},
  {value: 2, name: 'Против'},
  {value: 3, name: 'Воздержался'}
]

const CAN_CHANGE_ABSENT_POSITIONS = ['председатель комиссии', 'заместитель председателя комиссии', 'секретарь комиссии']

export default function ComissionBlock ({ requestId, reqUserId, commId }) {
  
  
  const { edu_expert, user_id } = useSelector(state => state.auth)
  const { list, values } = useSelector(state => state.common.comission)
  const dispatch = useDispatch()

  const alreadyApproved = values?.find(({mid}) => mid === user_id)
  const requestOwner = reqUserId === user_id

  const toggleAbsentStatus = (mid, absent) => () => {
    const body = { mid, absent: !absent }
    dispatch(toggleExpertAbsentStatus(commId, body, false))
  }

  const [status, setStatus] = useState('')

  useEffect(() => {
    const approveData = values?.find(({mid}) => mid === user_id)
    setStatus(approveData?.status || '')
  }, [values])
  
  const canChangeAbsentStatus = useMemo(() => list.filter(i => CAN_CHANGE_ABSENT_POSITIONS.includes(i.position.toLowerCase())).map(i => i.MID).includes(user_id), [])

  const renderRow = (expert, index) => {
    const {MID, expert_fio, position, absent} = expert
    const value = values?.find(({mid}) => mid === MID)
    const status = value?.status
    const createdAt = moment(value?.created_at).format('DD.MM.YYYY HH:mm')
    const switchHint = absent ? 'Отсутствует по уважительной причине' : 'Член комиссии присутствует'
    return (
      <tr key={index}>
        <td>{expert_fio}</td>
        <td>{position}</td>
        <td>
          <Switch
            hint={switchHint}
            checked={!absent}
            disabled={!canChangeAbsentStatus}
            onClick={toggleAbsentStatus(MID, absent)}
          />
        </td>
        <td title={value && 'Удалить подпись'} onClick={value && handleDelete(value)}>
          {status == 1
            ? <AiOutlineCheck size={22} color='#10d310'/>
            : status == 2
              ? <AiOutlineClose size={22} color='red'/>
              : status == 3
                ? <AiOutlineDash size={22} color='#ff8400'/>
                : ''
          }
          {value && <span className={styles.createdAt}>({createdAt})</span>}
        </td>
      </tr>
    )
  }

  const handleApprove = () => {
    const param = { status }
    dispatch(createComissionApprove(requestId, param))
  }

  const handleDelete = (value) => () => {
    if (value.mid !== user_id) return createNotification('error', 'Нельзя удалить чужую подпись');
    dispatch(deleteComissionApprove(value.id, requestId, false))
  }


  return (
    <div className={styles.comissionBlock}>
      <Table id='comissionTable'>
        <thead>
          <tr>
            <th>ФИО</th>
            <th>Должность</th>
            <th/>
            <th>Подпись</th>
          </tr>
        </thead>
        <tbody>
          {list?.length
            ? list.map(renderRow)
            : <tr className={styles.noDataRow}>
                <td colSpan={4}>Данные отсутствуют</td>
              </tr>
          }
        </tbody>
      </Table >
      {edu_expert &&
        <div className={styles.approveBlock}>
          <Form.Select
            value={status}
            style={{width: '200px'}}
            disabled={alreadyApproved || !list?.length || requestOwner}
            onChange={e => setStatus(e.target.value)}
          >
            <option value=''>Выбрать</option>
            {statuses.map(({name, value}) => <option value={value}>{name}</option>)}
          </Form.Select>
          <Button
            disabled={alreadyApproved || !list?.length || !status || requestOwner}
            onClick={handleApprove}
            label='Подписать'
          />
        </div>
      }
    </div>
  )
}
